import React, {PropsWithChildren, useContext} from 'react';
import * as S from './styles'
import { PanelButton } from './PanelButton';
import {PanelContext} from "./Panel";

export const PanelHeader = ({children}: PropsWithChildren<any>) => {
    const { variant } = useContext(PanelContext);

    return (
        <S.PanelHeader variant={variant}>
            {children}
            <PanelButton/>
        </S.PanelHeader>
    )
}